import { render } from "./NewCardForm.vue?vue&type=template&id=3294a113&scoped=true&lang=pug"
import script from "./NewCardForm.vue?vue&type=script&lang=ts"
export * from "./NewCardForm.vue?vue&type=script&lang=ts"

import "./NewCardForm.vue?vue&type=style&index=0&id=3294a113&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3294a113"

export default script